<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_v"><b>Contents</b></a></h1><a id="page_v">
</a><h2 class="tocfm"><a id="page_v"></a><a href="#/xhtml/06_Fm02">Preface – Letters Home</a></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter01"><span class="toc_hang">Chapter 1</span> Fly Navy – Training and Operational Context, 1968–70</a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chapter02"><span class="toc_hang">Chapter 2</span> Never Unprepared – 800 Naval Air Squadron, HMS <i>Eagle</i>, 1970–72</a></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample"><span class="toc_hang">Chapter 3</span> I Hear the Enemy – 845 Naval Air Commando Squadron, HMS <i>Hermes</i>, 1973–74</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample"><span class="toc_hang">Chapter 4</span> Immortal Fried Chicken – 809 Naval Air Squadron, HMS <i>Ark Royal</i>, 1974</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample"><span class="toc_hang">Chapter 5</span> The Gilroy Trophy – Preparation and Planning, 11 November 1974</span></h2>
<h2 class="tocbm"><span href="#/xhtml/12_Acknowledgements" title="Link target outside of Sample">Acknowledgements</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?6feca37e